import { SecondaryNodeColor } from './node.types';

export enum AnalysisInput {
  FILES = 'files',
  INPUT = 'textInput',
  VARIABLES = 'variables',
  INDUSTRIES = 'industries',
  COUNTRIES = 'countries',
}

export enum ExtendedDataTitle {
  DEFINITIONS = 'definitions',
  RESULTS = 'results',
}

export interface IAnalysisForm {
  [AnalysisInput.FILES]: File[];
  [AnalysisInput.INPUT]: string;
  [AnalysisInput.VARIABLES]: string[];
  [AnalysisInput.INDUSTRIES]: string[];
  [AnalysisInput.COUNTRIES]: string[];
}

export interface IResultTable {
  author: string;
  estimate: string;
  pValue: string;
  color?: SecondaryNodeColor;
}

export interface IResultTables {
  tableData: IResultTable[];
  tableTitle?: string;
}

export interface IResultsData {
  image: string;
  url?: string;
}

export interface IAnalysisNodeData {
  tables: IResultTables[];
  resultsData: IResultsData[];
  definitionsData: IResultsData[];
  description?: string;
  summaryCount?: [number, number, number];
}

export type IResultsAndDefinitionsData = Pick<IAnalysisNodeData, 'resultsData' | 'definitionsData'>;
